import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@dreamtree-org/twreact-ui';

/**
 * The header 35 pages were hand-rolling in two drifted variants (text-2xl on list
 * screens, text-xl on detail screens). One scale for both now.
 *
 * `subtitle`, `meta` and `actions` take nodes, not just strings — callers pass a Badge
 * beside the title (`meta`) and <Can>-gated buttons as `actions`.
 */
export default function PageHeader({ title, subtitle, meta, backTo, backLabel, actions, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-sm text-secondary-500 hover:text-secondary-700"
        >
          <ChevronLeft size={16} /> {backLabel || 'Back'}
        </Link>
      )}
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-semibold truncate">{title}</h1>
            {meta}
          </div>
          {subtitle && <p className="text-sm text-secondary-500">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
